/** Presentation helpers shared by both clients so times read identically. */
/** Final times, to hundredths: `9.87` or `2:03.45`. */
export function formatDuration(ms) {
    const totalSeconds = ms / 1000;
    const minutes = Math.floor(totalSeconds / 60);
    const seconds = totalSeconds - minutes * 60;
    if (minutes === 0)
        return seconds.toFixed(2);
    return `${minutes}:${seconds.toFixed(2).padStart(5, '0')}`;
}
/**
 * The running clock: whole seconds, like the original.
 * Decimals ticking away in your peripheral vision are just stressful.
 */
export function formatTimer(ms) {
    const total = Math.floor(ms / 1000);
    const minutes = Math.floor(total / 60);
    const seconds = total % 60;
    if (minutes === 0)
        return String(seconds);
    return `${minutes}:${String(seconds).padStart(2, '0')}`;
}
/** Coarse "when did this happen" label for leaderboard rows. */
export function formatAge(timestamp, now = Date.now()) {
    const seconds = Math.max(0, Math.round((now - timestamp) / 1000));
    if (seconds < 60)
        return 'just now';
    const minutes = Math.round(seconds / 60);
    if (minutes < 60)
        return `${minutes}m ago`;
    const hours = Math.round(minutes / 60);
    if (hours < 24)
        return `${hours}h ago`;
    const days = Math.round(hours / 24);
    if (days < 30)
        return `${days}d ago`;
    const months = Math.round(days / 30);
    if (months < 12)
        return `${months}mo ago`;
    return `${Math.round(months / 12)}y ago`;
}
//# sourceMappingURL=format.js.map